<template name = "dateTemplate" lang="html">
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>Search</h5>
				<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
			</div><!-- df-sidebar-header -->
			<div class="sidebar-body">
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label :for="form.id" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{experimentData[form.id]}}</p>
						<!-- <input type="email" class="form-control" :name="form.id" v-model.lazy="experimentData[form.id]" :id="form.id" :placeholder="form.name"> -->
					</div>
				</ul>
				<ul class="sidebar-nav" v-else-if="form.division === 'O'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == experimentData[form.id]">{{form1.codeName}}</span></p>
						<p class="mg-b-0 text-left" v-else>{{experimentData[form.id]}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left" v-for="(form1, j) in form.value" v-if="experimentData[form.id] == form1.codeCode">{{form1.codeName}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in dateRangeSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{experimentData[form.id]}}</p>
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
					<div class="form-group">
						<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
						<p class="mg-b-0 text-left">{{experimentData[form.id]}}</p>
					</div>
				</ul>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components overflow-hidden">
			<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
								<li class="breadcrumb-item">{{this.mainName}}</li>
								<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
								<li class="breadcrumb-item active" aria-current="page">View</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} View</h4>
						</nav>
					</div>
					<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="reportEditor()"><feather type="printer" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Report</button>

						<!--<router-link class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:'editor', params:{experimentHeader:experimentHeader, experimentData:experimentData, menuData:menuData, sampleData:this.sampleData, dprops:this.properties, type:'list'}}"><feather type="printer" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Report</router-link>-->
						<router-link class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" :to="{name:this.$route.name.replace('_completion',''), params:{mid:this.properties.mid, type:'list'}}"><feather type="file" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>list</router-link>
					</div>
				</div>
				<div class=" pd-x-0 pd-lg-x-10 pd-xl-x-0">
					<div class="col-sm-6 col-lg-5 d-inline-block">
						<ul class="cardborder nav nav-tabs" id="myTab" role="tablist">
							<li class="nav-item"><a class="nav-link active" id="experiment-tab" data-toggle="tab" href="#experiment" role="tab" aria-controls="experiment" aria-selected="true" @click="classifyData()">Experiment</a></li>
							<li class="nav-item"><a class="nav-link" id="reexperiment-tab" data-toggle="tab" href="#reexperiment" role="tab" aria-controls="reexperiment" aria-selected="false" @click="classifyReExpData()">ReExperiment</a></li>
						</ul>
					</div>
					<div class="d-inline-block" style="max-width: 57%;width: 100%;text-align: right;">
						<button v-if="this.downloadList.QC.length > 0" @click="reportDialogHandler()" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>QC_Report</button>
						<button v-if="imgData.length > 0" data-toggle="collapse" data-target="#ViewGel" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f"><feather type="image" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Gel</button>
						<div class="gel-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list collapse" style="max-width:1500px;" v-bind:style="{width: ((imgData.length*180)+(imgData.length*20))+'px'}" id="ViewGel">
										<!-- <div class="d-inline-block mr-1 overlay" :id="'imgBox'+i" v-for="(form, i) in imgData">
											<span class="d-block item-remove" v-on:click="deleteImgFile(form.id, i)"><i class="fa fa-times" aria-hidden="true"></i></span>
											<img class="d-block" :id="form.id" v-bind:src="'data:'+form.type.trim()+';base64,'+ form.img"/>
										</div> -->
											<div style="white-space:nowrap; overflow-x:scroll;">
												<imageViewerConfirm :image="imgData"/>
											<div class="chart-three clearfix">
												<div id="flotChart5" class="flot-chart ht-30"></div>
											</div>
										</div>
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewGel">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<button v-if="nanoData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f" data-toggle="collapse" data-target="#ViewNano"><nanoIcon fill="white" class="wd-15 hd-15 mg-r-5 "></nanoIcon>NANO DROP</button>
						<div class="gel-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list collapse" style="max-width:1500px;" v-bind:style="{width: ((nanoData.length*180)+(nanoData.length*20))+'px'}" id="ViewNano">
										<!-- <div class="d-inline-block mr-1 overlay" :id="'imgBox'+i" v-for="(form, i) in imgData">
											<span class="d-block item-remove" v-on:click="deleteImgFile(form.id, i)"><i class="fa fa-times" aria-hidden="true"></i></span>
											<img class="d-block" :id="form.id" v-bind:src="'data:'+form.type.trim()+';base64,'+ form.img"/>
										</div> -->
											<div style="white-space:nowrap; overflow-x:scroll;">
												<nanoViewerConfirm :image="nanoData"/>
											<div class="chart-three clearfix">
												<div id="flotChart5" class="flot-chart ht-30"></div>
											</div>
										</div>
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewNano">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						&nbsp;&nbsp;&nbsp;&nbsp;
						<button v-if="tapeData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f" data-toggle="collapse" data-target="#ViewTape"><tapeIcon fill="white" class="wd-15 hd-15 mg-r-5 "></tapeIcon>TAPE STATION</button>
						<div class="tape-container">
							<div class="row">
								<div class="cart">
									<div v-draggable class="items-list2 collapse" id="ViewTape">
										<tapeViewerConfirm :image="tapeData"/>
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div>
										<!-- <div class="d-lg-block align-items-end" :id="'tapeBox'+i" v-for="(form, i) in tapeData">
											<div class="border border-light rounded mg-4-f">
												<div class="d-block image-sample-font pl-2">{{form.sampleId}}</div>
												<div class="carousel"> -->
													<!-- <img class="d-block" :id="form.id" v-bind:src="'data:'+form.type.trim()+';base64,'+ form.img"/>
												</div>
											</div>
										</div> -->
										<div class="chart-three clearfix">
											<div id="flotChart5" class="flot-chart ht-30"></div>
										</div><!-- chart-three -->
										<div class="row">
											<div class="view-cart">
												<span class="close-cart" data-toggle="collapse" data-target="#ViewTape">Close</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card card-body pd-b-0-f">
						<div class="tab-content mg-t-20" id="myTabContent">
							<div class="tab-pane fade lm-overflow show active" id="experiment" role="tabpanel" aria-labelledby="experiment-tab">
								<div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
									<!-- <download-excel class = "btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" :data = "excelData" :fields = "excelHeader" worksheet = "My Worksheet" name = "filename.xls">EXCEL</download-excel> -->
                                    <!-- <a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="reExperiment()"><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>re-experiment</a> -->
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="reExpDialogHandler('re-experiment')" ><feather type="minus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>re-experiment</a>
								</div>
								<ul class="nav nav-line" id="myTab5" role="tablist">
									<li class="nav-item" v-for="(form, i) in tabHeader" v-if="properties.mid === form.id"><a class="nav-link active" v-on:click='classifySampleHeader(form.id, tabHeader.length, i)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a></li>
									<li class="nav-item" v-else><a class="nav-link"  v-on:click='classifySampleHeader(form.id, tabHeader.length, i)' :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false">{{form.menuName}}</a></li>
								</ul>
									<div class="card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25">
										<div class="d-none d-md-block tx-right-f">
                                            <a href="" @click='checkedRows = sampleData.filter(sample => sample.experimentResultcode == "Fail")' class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>fail-check</a>
											<a href="" @click="excelExport()" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-y-9-f" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Excel</a>
										</div>
										<section>
											<b-table id="btable" class="overflow-x-hidden b-table-fix-header" :data="isEmpty ? [] : sampleData" :checked-rows.sync="checkedRows" ref="table" checkable hoverable striped >
												<template slot-scope="props">
													<b-table-column v-for="(form, i) in sampleHeader" v-if="i == 0" :key="i" field="No" label="No">{{ props.row.no }}</b-table-column>
													<b-table-column v-else-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered sortable >
														<a href='#modal5' @click='sendId(props.row.id)' :id="props.index" data-toggle="modal" data-animation="effect-flip-horizontal"> {{ props.row[form.columnCode] }} </a>
													</b-table-column>
													<b-table-column v-else :key="i" :field="form.columnCode" :label="form.columnName" centered sortable >{{ props.row[form.columnCode] }}</b-table-column>
												</template>
												<template slot="empty">
													<section class="section">
														<div class="content has-text-grey has-text-centered">
														<p>Nothing here.</p>
														</div>
													</section>
												</template>
											</b-table>
										</section>
									</div><!-- card -->
							</div><!-- tab -->

							<div class="tab-pane fade" id="reexperiment" role="tabpanel" aria-labelledby="reexperiment-tab">
								<!--<div class="d-none d-md-block tx-right-f">
									<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" @click="addReExpSamples()" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add</a>
								</div>-->
									<ul class="nav nav-line mg-b-0-f" id="myTab5" role="tablist"> <!-- 이전 단계 및 현재 단계 재실험 확인 tab (이전단계 / 현재단계(재실험)) -->
										<!--<li class="nav-item" v-for="(form, i) in tabHeader" v-if="(tabHeader.length - 2) === i">
											<a class="nav-link active" @click="classifyWorkChange(form.id)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true" >{{form.menuName}}</a>
										</li>
										<li class="nav-item" v-else-if="(tabHeader.length - 1) === i">
											<a class="nav-link" @click="classifyWorkChange(form.id)" :id="form.id" data-toggle="tab" href="#" role="tab" aria-controls="profile" aria-selected="false" >Re-Experiment</a>
										</li>-->
									</ul>
								<section>
									<!--<b-table id='preTable' :data="isEmpty ? [] : reExpData" :checked-rows.sync="reCheckedRows" ref="table" striped checkable detailed paginated per-page="15" detail-key="id" :show-detail-icon="false" :opened-detailed="defaultOpenedDetails" @details-open="(row, index) => closeAllOtherToggle(row, index)"> <template slot-scope="props">-->
									<b-table id='preTable' :data="isEmpty ? [] : reExpData" ref="table" striped detailed paginated per-page="15" detail-key="id" :show-detail-icon="false" :opened-detailed="defaultOpenedDetails" @details-open="(row, index) => closeAllOtherToggle(row, index)"> <template slot-scope="props">
											<b-table-column v-for="(form, i) in reExpHeader" v-if="Number(i) == 1" :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>
												<a href='#' @click='toggle(props.row, tabHeader[tabHeader.length - 1].jobOrder)' :id="props.index"> {{ props.row[form.columnCode] }} </a>
											</b-table-column>
											<b-table-column v-else :key="form.id" :custom-key="form.id" :field="form.columnCode" :label="form.columnName" centered>{{props.row[form.columnCode]}}</b-table-column>
										</template>
										<template slot="empty">
											<section class="section">
												<div class="content has-text-grey has-text-centered">
												<p>Nothing here.</p>
												</div>
											</section>
											</template>
											<template slot="detail" slot-scope="props">
												<ul class="nav nav-line" id="myTab5" role="tablist"> 
													<li class="nav-item" v-for="(form, i) in tabHeader">
														<a class="nav-link" v-bind:class="{active:form.activeNav}" :id="form.id" @click="classifyReExpSamplesData(props.row, form.jobOrder)" data-toggle="tab" href="#" role="tab" aria-controls="home" aria-selected="true">{{form.menuName}}</a>
													</li>

													<a class="button is-light" style="margin-left:auto" @click="addReExpSamples()">
														<feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>
													</a>
												
												</ul>
												<b-table id="preSampleTable" :columns="reExpSampleColumns" :data="isEmpty ? [] : reExpSampleData" :checked-rows.sync="reSampleCheckedRows" ref="sampleTable" hoverable striped checkable></b-table>
											</template>
									</b-table>
									<div class='d-none'><b-table id='preSampleTable' ref="sampleTable"></b-table></div>
								</section>
							</div><!-- tab -->

						</div>
					</div><!-- card -->
					<div class="df-settings" :class="{'show': b_sh_well, '': !b_sh_well}">
						<div v-on:click="ptshow()" class="df-settings-link closed-cursor text-vertical-3">PLATE</div>
						<div class="df-settings-body">
							<div class="card card-body">
								<div class="mg-t-10 mg-sm-t-0">
									<h6 class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-0-f">Plate Well</h6>
									<div v-for='idx in well_plate' :id="'d-idx-'+idx" class='d-none'>
										<ul class="plate-board">
											<li class="fl tc w1 plate-list2 mg-t-10-f">({{idx}})</li>
											<li class="fl tc w1 plate-list2 mg-t-10-f" v-for='column in well_column'>{{(Number(column))}}</li>
										</ul>
										<!--- 리스트 --->
										<ul class="plate-board" v-for='row in well_row'>
											<li class="fl tc plate-w2 plate-list2 pt-sm-2">{{well_row_a[(Number(row)-1)]}}</li>
											<div :id="'list'+idx+'-'+row">
												<li class="fl tc plate-w2 list1 pt-sm-2"  v-for='column in well_column' :id='well_row_a[(Number(row)-1)]+column'>
													<div>{{well_row_a[(Number(row)-1)]}}{{(Number(column))}}</div>
												</li>
											</div>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal fade" id="modal5" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel5" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered chat-width" role="document">
				<div class="modal-content tx-14 chat-height">
					<div class="modal-header">
						<h6 class="modal-title" id="exampleModalLabel5">Chat</h6>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<Chat></Chat>
					</div>
				</div>
			</div>
		</div><!-- chat modal -->
			<v-app id="inspire">
            <div>
                <v-row
                    justify="center"
                >
                    <v-dialog
                    v-model="reportDialog"
                    max-width="500px"
                    style='z-index:20001;'
                    >
                        <v-card>
                            <v-card-title>
                            Download Report
                            </v-card-title>
                            <v-card-text>
                            <v-select
                                v-model="selectReport"
                                :items="downloadList['QC']"
                                label="Select a report"
                                item-value="text"
                            ></v-select>
                            </v-card-text>
                            <v-card-actions>
                            <v-btn
                                color="secondary"
                                text
                                @click="reportDialog = false"
                            >
                                Close
                            </v-btn>
                            <v-btn
                                color="primary"
                                text
                                @click="loadQC_Report()"
                            >
                                Load
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div> 	
        </v-app>
        <v-app id="inspire">
            <div>
                <v-row justify="center">
                    <v-dialog v-model="reExpDialog" max-width="500px" style='z-index:20001;'>
                        <v-card>
                            <v-card-title>
                                Re-Experiment
                            </v-card-title>
						
                              <!--  <v-card-text>
                                    <v-select
                                    v-model="selectStep"
                                    :items="reMenu"
                                    label="1.Please select a step."
                                    item-value="id"
                                    item-text="menuName"
                                    ></v-select>
                                </v-card-text> -->
                                <v-card-actions>
                                    <v-expand-transition>
                                        <v-card
                                            class="transition-fast-in-fast-out v-card--reveal"
                                            style="height: 100%; width: 100%;"
                                        >
										<v-card-text class="pb-0">
                                            <div>1. Please enter the name.</div>
                                        </v-card-text>
										<v-container>
											<v-col
											cols="12"
											sm="6"
											>
											<v-text-field
												v-model="reExpName"
												hint="This field uses experiment name"
												label="Experiment Name"
											></v-text-field>
										</v-col>
										 </v-container>
                                        <v-card-text class="pb-0">
                                            <div>2. Please enter the number.</div>
                                        </v-card-text>
                                         
                                            <v-container>
                                            <v-data-table :headers="reHeaders" :items="this.checkedRows" class="elevation-1" >
                                                <template v-slot:item.qty="props">
                                                    <v-text-field v-model="props.item.qty" :rules="qtyRule"></v-text-field>
                                                </template>
                                            </v-data-table>
                                            </v-container>
                                            <v-card-actions>
                                                <v-btn color="primary" text @click="reExpDialog = false" > Close </v-btn>
                                                <v-btn color="primary" text @click="reExperiment()" > Create </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-expand-transition>
                                </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </div>
        </v-app>
        <v-app>
            <div>
                <v-row justify="center">
                    <v-dialog
                    v-model="confirmDialog"
                    style='z-index:20001;'
                    max-width="290"
                    >
                    <v-card>
                        <template>
                        <v-card-title class="text-h5">
                            <h5>{{dialTitle}}</h5>
                        </v-card-title>
                        <v-card-text>
                            <label>{{dialMsg}}</label>
                        </v-card-text>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                    <!--        <div v-if="dialogBoolean">
                                <v-btn color="dark" text @click="confirmDialog = false" >
                                    OK
                                </v-btn>    
                            </div> -->
                            <div v-if="dialogBoolean">
                                <v-btn color="dark" text @click="confirmDialog = false" >
                                    No
                                </v-btn>
                                <v-btn v-if="dialogBoolean" color="dark" text @click="reExperiment()" >
                                    Yes
                                </v-btn>
                            </div>
                            <div v-else>
                                <v-btn color="dark" text @click="confirmDialog = false" >
                                    Yes
                                </v-btn>
                            </div>
                        </v-card-actions>
                        </template>
                    </v-card>
                    </v-dialog>
                </v-row>
            </div>
        </v-app>
        <!-- 
		 <v-app id="inspire">
			<v-row justify="center">
				<v-dialog
					v-model="divisionDialog"
					persistent
					max-width="290"
				>
					<v-card>
					<v-card-title class="text-h6">
						Are you sure you want to delete?
					</v-card-title>
					<v-card-actions>

						<v-card-text>
							<v-row
							class="mb-4"
							justify="space-between"
							>
							<v-col class="text-left">
								<span
								class="text-h2 font-weight-light"
								v-text="divisionCount"
								></span>
								<span class="subheading font-weight-light mr-1">EA</span>
					
							</v-col>
						
							</v-row>

								<v-icon
								:color="color"
								@click="decrement"
								>
								mdi-minus
								</v-icon>
								<v-icon
								:color="color"
								@click="increment"
								>
								mdi-plus
								</v-icon>
						</v-card-text>

						<v-spacer></v-spacer>
						<v-btn
						color="secondary"
						text
						@click="divisionDialog = false"
						>
						Cancel
						</v-btn>
						<v-btn
						color="primary"
						text
						@click="sampleDivision()"
						>
						Division
						</v-btn>
					</v-card-actions>
					</v-card>
				</v-dialog>
			</v-row>
		</v-app> -->

	</div>
	
</template>
<script>
	// 공통 함수 관리 파일 임포트
	import common from "@/views/Common/common.js";
	// 멀티 드래그 앤 드롭 임포트
	import { Sortable, MultiDrag, Swap } from "sortablejs";
	Sortable.mount(new MultiDrag());
	Sortable.mount(new Swap());

	// Header의 메뉴 정보 호출을 위한 bus event
	import { bus } from "../../main";
	// 이미지 드래거블
	import { Draggable } from 'draggable-vue-directive'
	// 결재, 채팅  
	import Approval from "@/views/Common/Approval";
	import Chat from "@/views/Common/Chat";
	import imageViewerConfirm from "@/views/Common/image-upload/ViewerConfirm";
	import tapeViewerConfirm from "@/views/Common/image-upload/ViewerTapeConfirm";
	import nanoViewerConfirm from "@/views/Common/image-upload/ViewerNanoConfirm";
	import excel from '@/views/Common/excel.js';

	export default {
		name: "Detail",
		props: ["properties"],
		directives: {
		Draggable,
		},
		data() {
			return {
				mainName: "",
				subName: "",
				menuData: [], // header.vue data

				pdfPath:'',
				pdfId: [],

				mid: "", // menu list id
				msid: "", // menu sheet id
				uid: "", // sheet id
				ssid: "", // sample list id
				rowNum: "", // sample group row number

				/* Experiment input Form */
				experimentHeader: [], // 입력 값 header column
				inputSearchForms: [], // 입력 input form
				dateSearchForms: [], // 입력 date form
				dateRangeSearchForms:[], // 입력 date range form
				checkboxSearchForms: [], // 입력 radio form

				/* Experiment 정보 Form Value */
				experimentData: [], // 실험 정보 확인

				/* tab Header */
				tabHeader: [],
				checkedRows: [], // 그룹 체크 row 확인
				isEmpty: false,

				/* Sample Form */
				sampleHeader: [], // Experiment Sample Header
				sampleData: [], // Experiment Sample list data

				/* Well Plate index */
				well_column: 12,
				well_row: 8,
				well_row_a: ["A", "B", "C", "D", "E", "F", "G", "H"],
				well_data: [],
				well_plate:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50],
				b_sh_well: false,

				last_plate:'', // 마지막 plate code

				/* Loading */
				isLoading: false,
				isFullPage: true,

				/* file upload */
				formData: "",
				uploadFlag: false,
				imgData: [],
				imgId: [],
				
				/* Tape Staion */
				tapeData:[],
				tapeId: [],

				width: 0,
				height: 0,

				/* Nano Drop */
				nanoData: [],
				nanoId: [],

				// division
				divisionDialog: false,
				divisionCount: 1,

				// pdf
				pdfFlag: false,
				pdfData:[],
				pdfId: [],
				pdfFileFormData: new FormData,
				pdfFileHandleFlag: false,

				/* QC Report */
				reportDialog: false,
				deleteDialog: false,
				selectReport: '',
				downloadList: {
					"QC": [],
				},

                reExpDialog :false,
                confirmDialog : false,
                dialTitle : "",
                dialMsg : "",
				dialogBoolean: false,
                reHeaders: [
                    // { text: 'ID', value: 'duid' },
                    { text: 'No', value: 'no' },
                    { text: 'Sample No.', value: 'sampleNo' },
                    { text: 'QTY', value: 'qty' },
                ],
				qtyRule: [
					v => !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/.test(v) || 'enter the numbers.',
				],



				//reexp
				reExpData: [],
				reExpHeader: [],
				defaultOpenedDetails:[],
				reExpSampleData: [],
				defaultReExpSampleData: [],
				reExpSampleColumns: [],
				reSampleCheckedRows:[], // sample 체크 row 확인
				reCheckedRows:[], // sample 체크 row 확인
				presentMenu:[], // 현재 메뉴 
				selectedReGroup: [], // 선택 탭 그룹
				selectedReJobOrder: '', //선택 탭 잡오더,
				reExpName:'',
				expName: {},

			};
		},
		beforeDestroy() {
			bus.$off("menu_data");
			window.removeEventListener("scroll", this.onScroll);
		},
		created() {
			// this.openLoading();
			bus.$on("menu_data", data => {
				this.menuData = data;
				this.classifyHeader();
				this.getPdf();

			});
			this.getImgFile();
			this.getTapeFile();
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
	
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		mounted() {
			this.$nextTick(function (){
				$("#gelimage").draggable();
				$("#tapeimage").draggable();
			});
			window.addEventListener("scroll", this.onScroll);
		},
		methods: {
			/*
			* Load Data Reception Headers
			*/
			async classifyHeader() {
				let data = common.menuHeader(this.properties.mid, this.menuData);
				this.mainName = data[0];
				this.subName = data[1];
				this.msid = data[2];
				this.experimentHeader = data[3];
				this.tabHeader = common.tabOrder(this.properties.mid, this.menuData);

				// create re-experiment menu
				for (let i = 0; i < this.tabHeader.length; i++) {
					this.tabHeader.activeNav = false;
				}
				this.tabHeader[this.tabHeader.length - 1].activeNav = true;

				this.inputSearchForms = [];
				this.dateSearchForms = [];
				this.checkboxSearchForms = [];
				for (let i in this.experimentHeader) {
					if (this.experimentHeader[i].columnType == "LIST") {
						if (this.experimentHeader[i].columnAttr == "statecode") {
							this.inputSearchForms.push({name: this.experimentHeader[i].columnName,value: this.experimentHeader[i].code,id: this.experimentHeader[i].columnCode,division: "O"});
						} else {
							this.checkboxSearchForms.push({name: this.experimentHeader[i].columnName,id: this.experimentHeader[i].columnCode,value: this.experimentHeader[i].code,division: this.experimentHeader[i].columnDivision});
						}
					} else if (this.experimentHeader[i].columnType == "DATE") {
						this.dateSearchForms.push({name: this.experimentHeader[i].columnName,value: "",id: this.experimentHeader[i].columnCode,division: this.experimentHeader[i].columnDivision});
					}else if (this.experimentHeader[i].columnType == "DATERANGE") {
						this.dateRangeSearchForms.push({name: this.experimentHeader[i].columnName,id: this.experimentHeader[i].columnCode,fvalue: "",evalue: "",fid: "f_" + this.experimentHeader[i].columnCode,eid: "e_" + this.experimentHeader[i].columnCode});

					}else if (this.experimentHeader[i].columnType == "COUNT") {
					} else {
						if (this.experimentHeader[i].columnName == "No") {
						} else {
							if (!common.isNull(this.properties.uid)) {
								if (this.experimentHeader[i].columnName == '실험명') {
									this.expName = this.experimentHeader[i]
								}
								this.inputSearchForms.push({name: this.experimentHeader[i].columnName,value: "",id: this.experimentHeader[i].columnCode,division: this.experimentHeader[i].columnDivision});
							} else {
								if (this.experimentHeader[i].columnDivision == "C") {
							
									this.inputSearchForms.push({name: this.experimentHeader[i].columnName,value: "",id: this.experimentHeader[i].columnCode,division: this.experimentHeader[i].columnDivision});
								}
							}
						}
					}
				}
				this.classifySampleHeader(this.properties.mid);
			},
			/*
			* Load Headers & Samples Data
			*/
			async classifyData() {
				this.sampleData = [];
				var thisData = [];
				var sampleData = [];
				if (!common.isNull(this.properties.uid)) {
                    this.openLoading();

					var params = [];
					if (Array.isArray(this.ssid)) this.ssid = this.ssid[0];
					params = { ssid: this.ssid };
					params["uid"] = this.properties.uid;
					var request = { params: params };
					await this.$axios.get(this.$apiHost + "/experiments/detail", request)
					.then(res => {
                        console.log(res.data)
						this.experimentData = res.data;
						this.reExpName = `${this.experimentData[this.expName.columnCode]}-R`;
                        this.isLoading = false;
					})
					.catch(err => {console.log(err);});
					sampleData = common.makeData(this.experimentData.samples, 1);
					let plate_row = sampleData.length%96 > 0 ? parseInt(sampleData.length/96) + 1 : parseInt(sampleData.length/96);
					for(let i = 0;i<plate_row;i++) document.getElementById('d-idx-'+(Number(i) + 1)).classList.toggle('d-none');
					for (let i in sampleData) {
                        delete sampleData[i].id
						sampleData[i].no = Number(i) + 1;
                        sampleData[i].qty = 1;
						for (let j in this.sampleHeader) {
							// columnAttr이 plate 인경우 plate 위치를 찾아서 넣어준다.
							let colorCode = this.$randomColor();
							let plate = 0;
							this.well_plate.some(a => {
								if(Number(i)+1 <= a*96){
									plate = a;
									return true;
								}
							});
							if (this.sampleHeader[j].columnAttr === "plate") {
								if(this.sampleHeader[j].columnCode === this.last_plate){
									// if (sampleData[i][this.sampleHeader[j].columnCode] && sampleData[i][this.sampleHeader[j].columnCode].indexOf('-') > 0) {
									// 	let dash_idxof = sampleData[i][this.sampleHeader[j].columnCode].indexOf('-')
									// 	let id = 'list' + sampleData[i][this.sampleHeader[j].columnCode].substring(0,dash_idxof) +'-'+ (Number(this.well_row_a.indexOf(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+1,1)))+1)
									// 	let list = document.getElementById(id);
									// 	list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+2,sampleData[i][this.sampleHeader[j].columnCode].length))-1].innerText = Number(i)+1;
									// 	list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+2,sampleData[i][this.sampleHeader[j].columnCode].length))-1].style.color = '#ffffff';
									// 	list.childNodes[Number(sampleData[i][this.sampleHeader[j].columnCode].substr(Number(dash_idxof)+2,sampleData[i][this.sampleHeader[j].columnCode].length))-1].style.backgroundColor = colorCode;
									// }
								}
							}
						}
                        //왜 배열
						this.sampleData.push(sampleData[i]);
						
					}
				}
				let height = (Number(this.height) - (Number(this.height)/1.9))+'px';
				document.getElementById('btable').style.height = height;
				this.isLoading = false;
			},
			/*
			* First Load Previous Data & Samples Data
			*/
			async classifySampleHeader(id, tab_len, idx) {
				idx = (tab_len - 1) == idx ? '' : tab_len;
				this.sampleHeader.splice(0, this.sampleHeader.length);
				this.$refs.table.newColumns.splice(0, this.$refs.table.newColumns.length);
				let thisMid = id.replace(/ /gi, "");
				let parse = [];
				if (common.isNull(thisMid)) thisMid = this.properties.mid;
				let data = common.isNull(idx) ? common.makeHeader(thisMid, this.menuData, 2) : common.makeHeader(thisMid, this.menuData, 2, tab_len);
				if(thisMid == this.properties.mid) this.ssid = data[0];
				parse = data[1];
				parse.forEach((a,b)=>{
					if(Number(b)===0){
						this.sampleHeader = this.sampleHeader.concat({columnCode:'No'});
						this.sampleHeader = this.sampleHeader.concat(a);
					}else{
						if(a.mid === thisMid) this.sampleHeader = this.sampleHeader.concat(a);
                        else if (!a.hasOwnProperty('mid')) this.sampleHeader = this.sampleHeader.concat(a);
                        else if(a.columnAttr == 'samplebarcode' || a.columnAttr == 'samplename') this.sampleHeader = this.sampleHeader.concat(a);
					}
				});
				if(common.isNull(this.last_plate)) this.last_plate = common.find_last_column(this.sampleHeader, 'plate');
				this.classifyData();
			},
			/*
			* List page Move (리스트 목록 페이지 이동)
			*/
			goPage() {
				
			},
			/*
			* file upload
			*/
			async getImgFile() {
				//img 가져오기
				if (!common.isNull(this.properties.uid)) {
					var params = [];
					params = { uid: this.properties.uid };
					var request = { params: params };
					await this.$axios.get(this.$apiHost +"/" +this.$route.name.replace("_completion", "") +"/getimage",request)
					.then(res => {
						for (let i in res.data) {
							if (res.data[i].classification === 'gel') {
								this.imgData.push(res.data[i]);
							} else {
								this.nanoData.push(res.data[i]);
							}
						}
						if (!common.isNull(this.imgData)) {
							for (let i in this.imgData) {
								this.imgId.push(this.imgData[i].id);
								let image = this.imgData[i].img;
							}
						}
						if (!common.isNull(this.nanoData)) {
							for (let i in this.nanoData) {
								this.nanoId.push(this.nanoData[i].id);
								let image = this.nanoData[i].img;
							}
						}
					});
				}
			},

			async getPdf(){
				try {
					if(!common.isNull(this.properties.uid)){
						let params = [];
						params = {
							'id' : this.properties.uid
						};
						let request = {params : params};
						const result = await this.$axios.get(`${this.$apiHost}/files/pdf`, request);
					
						if (result.data.length > 0) {
							let path = [];
							for (let i of result.data) {
								path.push(i.fileName)
								this.pdfId.push(i.id)
							}
							this.downloadList.QC = path;
							this.downloadList.QC_info = result.data;
						}
						return false;
					} else {
						return false;
					}

				} catch (error) {
					console.log(error);
				}
			},
			async reportDialogHandler(){
				this.reportDialog = true;
				return false;
			},
			errorAlert(message) {
   				this.$buefy.dialog.alert({
					message,
					size: 'is-medium',
					type: 'is-danger'
				})
				return false;
			},
            async reExpDialogHandler(input) {
				let message = '';
				if(this.checkedRows.length == 0){
					this.errorAlert('Please select a samples to Re-Experiment.');

				} else {
					this.reExpDialog = true;
				}
             

                // if(input == "re-experiment"){
                //     if(this.checkedRows.length == 0){
                //         this.confirmDialog = true;
                //         this.dialTitle = "WARNING";
                //         this.dialMsg = "Please select a samples to Re-Experiment.";
                //     }else{
                //         this.reExpDialog = true;
                //     }
                // }else if(input == "confirmDialog"){
                //     if(common.isNull(this.selectStep)){
                //         this.confirmDialog = true;
                //         this.dialTitle = "WARNING";
                //         this.dialMsg = "Please select the experiment step.";
                //     }else{
				// 		for (let i of this.checkedRows) {
				// 			if (!i.qty1) {
				// 				this.confirmDialog = true;
				// 				this.dialTitle = "WARNING";
				// 				this.dialMsg = "Please enter the sample qty.";
				// 				return false;
				// 			} 
				// 		}
                //         this.confirmDialog = true;
                //         this.dialTitle = "CREATE";
                //         this.dialMsg = "Do you want to re-experiment with selected samples?";
				// 		this.dialogBoolean = true;
                //     }
                    
                // }
				return false;
			},
			dialogAlert(title, message) {
				this.confirmDialog = true;
				this.dialMsg = message;
				this.dialTitle = title;
			},
			/*
			* QC Report 
			*/
			async loadQC_Report(){
				try {
					if (this.selectReport) {
						let path = `https://lims.accugenelab.com/pdf/QC_Report/${this.selectReport}`;
						window.open(path);

						this.selectReport = '';
						this.reportDialog = false;

						return false;
					} else {
						this.$buefy.dialog.alert({
							message: 'Please select a report',
							size: 'is-medium',
							type: 'is-danger'
						})
						return false;
					}

				} catch (error) {
					console.log(error);
				}
			},
			/*
			* tapeStaion
			*/
			async getTapeFile() {
				//img 가져오기
				if(!common.isNull(this.properties.uid)){
					var params = []; 
					params = {'uid' : this.properties.uid};
					var request = {params : params}
					await this.$axios.get(this.$apiHost +'/'+this.$route.name.replace('_completion','')+'/gettape', request)
					.then(res=>{
						this.tapeData = res.data;
						this.tapeData.sort((a, b) => {
							return Number(a.sampleId.substr(a.sampleId.length-4)) - Number(b.sampleId.substr(b.sampleId.length-4));
						})
						if (!common.isNull(this.tapeData)) {
							for (let i in this.tapeData) {
								this.tapeId.push(this.tapeData[i].id);
							}
						}
					})
				} 
			},
			/*
			* Experiment Data Check All
			*/
		
			/*
			* b-table Reception no click is chat.vue send uuid
			*/
			sendId(id){
				bus.$emit("receptid", id);
			},
			/*
			* page Loading bar
			*/
			openLoading() {
				this.isLoading = true;
				// setTimeout(() => {this.isLoading = false;}, 10 * 100);
			},
			/*
			* Plate div 보이기/숨기기
			*/
			ptshow(){
				if(this.b_sh_well) this.b_sh_well = false;
				else this.b_sh_well = true;
			},
			onScroll(e) {
			},
			handleResize() {
				this.width = window.innerWidth;
				this.height = window.innerHeight;
			},
			excelExport(){ 
				excel.excelExportDataParser(this.sampleData, this.sampleHeader);
			},
			async reExperiment(){
                this.openLoading();
				let param = [];
				for (let i of this.checkedRows) {
					if (!i.qty) {
						this.dialogAlert('Warning', 'Enter the sample quantity.');
						// this.errorAlert('Enter the sample quantity.');
						this.isLoading = false;
						return false;
					} else {
						let json = {
							"id": i.duid,
							"qty": i.qty,
						}
						param.push(json);
					}
				}
                // let params = {jobOrder: this.tabHeader[(this.tabHeader.length - 1)]['jobOrder'], platecolumncode: common.find_last_column(this.sampleHeader, "plate"), samples: []};
				// var reWaitCnt = 0;
				let params = {
					"headerId": this.properties.uid,
					"menuId": this.properties.mid, 
					"samples": param,
					"reExpName": this.reExpName
				};

				const result = await this.$axios.post(this.$apiHost+'/experiments/reexp', params);
				this.reExpDialog = false;
				this.isLoading = false;
				this.$buefy.notification.open({
					duration: 5000,
					message: 'complete',
					position: 'is-bottom-right',
					type: 'is-success',
					hasIcon: true
				})
            },
			async classifyReExpData() {
				// classifying ReExperiment tab data(column, row data, present menu, ...)
			
				let params = [];
				params = {
					"menuSheetId": this.msid,
					"sampleSheetId": this.ssid,
					"menuId": this.properties.mid,
					"uId": this.properties.uid,
				};
				let request = {params : params};
				const res = await this.$axios.get(this.$apiHost + '/experiments/reexp', request);
				
				this.reExpData = res.data.data;
				this.reExpHeader = res.data.headerColumn;
				
			},
			async classifyReExpSamplesData(group, jobOrder) {

				this.reSampleCheckedRows = [];
				this.defaultReExpSampleData = [];
				this.presentMenu = [];
				this.reExpSampleData = [];
				this.reExpSampleColumns = [];

				this.selectedReGroup = group;
				this.selectedReJobOrder = jobOrder;
				let presentTab = {};
				//classify menu tab
				for (let i of this.tabHeader) {
					if (i.jobOrder == jobOrder) {
						i.activeNav = true;
						if (i.id == this.properties.mid) presentTab = i;
					} else {
						i.activeNav = false;
					}
				}

				// classifying ReExperiment tab data(column, row data, present menu, ...)
				let params = [];
				params = {
					"headerId": group.id,
					"menuSheetId": this.msid,
					"sampleSheetId": this.ssid,
					"menuId": this.properties.mid,
					"jobOrder": jobOrder,
				};
				let request = {params : params};
				this.isLoading = true;
				const res = await this.$axios.get(this.$apiHost + '/experiments/reexpsamples', request);
				console.log(res.data.defaultSamples)
				//초기화
				this.defaultReExpSampleData = res.data.defaultSamples;
				this.presentMenu = res.data.presentMenu;
				this.reExpSampleData = res.data.sampleData;
				this.reExpSampleColumns = res.data.sampleColumns;

				this.isLoading = false;
				return false;
			},
			async addReExpSamples() {
				let addSamples = [];
				if (this.reSampleCheckedRows.length > 0) {
					// 디폴트랑 아이디가 다르면
					// 디폴트 샘플아이디 == 샘플아이디 => 실험
					// 디폴트 아이디 == 샘플아이디 => 접수 
					this.isLoading = true;
					//현재 선택 시트 확인 (detail sheet Id check)
					let selectedTab = this.tabHeader.filter(item => item.activeNav)[0].detailColumn[0];
					let selectedTabdetailSheetId = selectedTab ? selectedTab.sheetId : '';
				
					let presentTabDetailSheetId = this.presentMenu.detailSheetid;
				
					if (selectedTabdetailSheetId == presentTabDetailSheetId) {
						// 현재 메뉴
						addSamples = this.reSampleCheckedRows;
					} else {
						for (let i of this.reSampleCheckedRows) {
							let presentSample = this.defaultReExpSampleData.find(item => item.id == i.presentExpDetailId);

							if (presentSample) addSamples.push(presentSample);
						}
					}

					let params = [];
					params = {
						"uId": this.properties.uid,
						"samples": addSamples, 
					};
					const reAdd = await this.$axios.post(this.$apiHost+'/experiments/reexpsamples', params);

					// 1. BackEnd - 샘플 추가 (기존 헤더 그룹으로 update/ 헤더 길이 0일시 usedCode 0) 
					// 2. Front - back 추가 되고 this.reSampleCheckedRows 초기화 classifyReExpData()
					console.log(reAdd.data)
					if (reAdd.data.oldHeaderReExpCount > 0) {
						console.log('추가있음')
						this.defaultOpenedDetails = [];
						this.toggle(this.selectedReGroup, this.selectedReJobOrder);
					} else {
						console.log('추가없음')
						this.closeAllOtherToggle(this.selectedReGroup, this.selectedReJobOrder);
						this.classifyReExpData();
					}
					this.isLoading = false;
					return false;


				} else {
					this.$buefy.dialog.alert({
						message: 'Please select a sample.',
						size: 'is-medium',
						type: 'is-danger'
					})
					return false;
				}
				return false;

			},	
			async reportEditor() {
				try{
					if (this.checkedRows.length == 0) {
						this.$buefy.dialog.alert({
							message: 'Please select a sample.',
							size: 'is-medium',
							type: 'is-danger'
						})
						return false;
					}
			
					this.$router.push({ name: 'editor', params: {experimentHeader:this.experimentHeader, experimentData:this.experimentData, menuData:this.menuData, sampleData:this.checkedRows, dprops:this.properties, type:'list'}})
				
				}catch(error){
					console.log(error);
				}
			},
					
			/*
			* buefy 테이블 현재 토글 디테일 창 열기
			*/
			toggle(row, jobOrder) {

				// 본인 토글 창이 열려있을때 창 닫기.. b-table 설정에 defaultOpenedDetails 배열은 현재 열린 창이 입력 되도록 되어 있음
				if(row.id === this.defaultOpenedDetails[0]){
					this.defaultOpenedDetails = []
				}else{ // 토글 창이 닫혀있을때 실행
					this.$refs.table.toggleDetails(row);
					this.defaultOpenedDetails = [row.id]
					this.classifyReExpSamplesData(row, jobOrder);	
				}
			},
			/*
			* buefy 테이블 이전 토글 디테일 창 닫기 b-table 설정에 toggle 창 실행 시 이전 창은 닫히고 현재 선택 창이 열리도록 설정 되어 있음
			*/
			closeAllOtherToggle(row, index) {
				this.defaultOpenedDetails = []
				this.defaultOpenedDetails = [row.id]
			},
		},

		components: {
			Approval,
			Chat,
			imageViewerConfirm,
			tapeViewerConfirm,
			nanoViewerConfirm
		},
		computed: {},
		watch: {}
	};
</script>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Experiment/CompletionForm.vue